var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-echart',{staticClass:"line-echart",attrs:{"id":"line-echart","width":"100vw","height":"100vh","option":_vm.option}})
}
var staticRenderFns = []

export { render, staticRenderFns }